type DrillDownFilterParts = {
  dimensionValue?: string;
  week?: number | string;
  year?: string | number;
};

const hasDrillDownFields = (value: Record<string, unknown>): value is DrillDownFilterParts =>
  "dimensionValue" in value && ("week" in value || "year" in value);

export const formatDrillDownFilterTitle = (filterValue: string): string => {
  try {
    const parsed: unknown = JSON.parse(filterValue);
    if (typeof parsed !== "object" || parsed === null || Array.isArray(parsed)) {
      return filterValue;
    }
    const record = parsed as Record<string, unknown>;
    if (!hasDrillDownFields(record)) {
      return filterValue;
    }
    const parts: string[] = [];
    if (typeof record.dimensionValue === "string" && record.dimensionValue.length > 0) {
      parts.push(record.dimensionValue);
    }
    const weekExists = record.week !== undefined && record.week !== null && record.week !== "";
    if (weekExists) {
      parts.push(`Semana ${record.week}`);
    }
    if (record.year !== undefined && record.year !== null && record.year !== "") {
      parts.push(String(record.year));
    }
    return parts.length > 0 ? parts.join(" · ") : filterValue;
  } catch {
    return filterValue;
  }
};
